import React, { Children, useState, useRef, useEffect, Component } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "reducers/drawer";
import { func, bool } from "prop-types";

import classNames from "classnames";

import Button from "pages/_components/Button";
import "./AccountModal.css";

const Options = (props) => {
    const { children, options, handleClose } = props;

    const optionsRef = useRef(null);
    const isVisible = useSelector(({ drawer }) => drawer.displayMenu);
    const dispatch = useDispatch();

    const closeMenu = () => {
        dispatch(actions.menuClose());
    };

    const handleClick = (event) => {
        if (optionsRef.current && !optionsRef.current.contains(event.target) && isVisible) {
            if (handleClose) {
                handleClose();
            } else {
                closeMenu();
            }
        }
        if (optionsRef.current && optionsRef.current.contains(event.target)) {
            closeMenu();
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClick, true);
        return () => {
            document.removeEventListener("click", handleClick, true);
        };
    }, [handleClick]);

    // const renderChildren = () => {
    //     return Children.toArray(children).reduce((result, child, index) => {
    //         if (child) {
    //             const id = index;
    //             return [
    //                 ...result,
    //                 React.cloneElement(
    //                     <li className="navigational-list-item" key={id}>
    //                         {child}
    //                     </li>,
    //                 ),
    //             ];
    //         }
    //         return result;
    //     }, []);
    // };
    return (
        <div className={classNames("slider", "slideFromBottom", { "is-shown": isVisible })}>
            <div ref={optionsRef} className="slideFromBottom-wrapper">
                <Button block className="btn btn-link drawer-close" onClick={closeMenu} image="drawer-close.svg" />
                <ul className="navigational-list">
                    {Children.map(
                        children,
                        (child, index) =>
                            child &&
                            React.cloneElement(
                                child.key !== "account.transfers" ? (
                                    <li className="navigational-list-item" key={index}>
                                        {child}
                                    </li>
                                ) : (
                                    <ul className="navigational-list">{child}</ul>
                                ),
                            ),
                    )}
                </ul>
            </div>
        </div>
    );
};
// class Options extends Component {
//     constructor(props) {
//         super(props);
//         this.optionsRef = React.createRef();

//         document.addEventListener("click", handleClick, true);
//     }

//     handleClick = (event) => {
//         const { dispatch } = this.props;

//         if (this.optionsRef.current && !this.optionsRef.current.contains(event.target) && isVisible) {
//             if (handleClose) {
//                 handleClose();
//             } else {
//                 dispatch(accountsActions.toggleOptions());
//             }
//         }
//     };
//     componentDidMount() {
//         document.addEventListener("click", handleClick, true);
//     }

//     componentWillUnmount() {
//         document.removeEventListener("click", handleClick, true);
//     }

//     // useEffect(() => {
//     //     document.addEventListener("click", handleClick, true);
//     //     return () => {
//     //         document.removeEventListener("click", handleClick, true);
//     //     };
//     // }, [handleClick]);

//     // handleClickOutside = (event) => {
//     //     if (optionsRef.current && !optionsRef.current.contains(event.target)) {
//     //         handleClose();
//     //     }
//     // };

//     render() {
//         return (
//             <div className={classNames("slider", "slideFromBottom", { "is-shown": isVisible })}>
//                 <div ref={this.optionsRef} className="slideFromBottom-wrapper">
//                     <Button block className="btn btn-link" onClick={handleClick} image="drawer-close.svg" />
//                     <ul className="navigational-list">
//                         {Children.map(
//                             children,
//                             (child, index) =>
//                                 child &&
//                                 React.cloneElement(
//                                     child.key !== "account.transfers" ? (
//                                         <li className="navigational-list-item" key={index}>
//                                             {child}
//                                         </li>
//                                     ) : (
//                                         <ul className="navigational-list">{child}</ul>
//                                     ),
//                                 ),
//                         )}
//                     </ul>
//                 </div>
//             </div>
//         );
//     }
// }

// const mapStateToProps = (state) => ({
//     isVisible: accountsSelectors.getIsOptionsVisible(state),
// });

Options.propTypes = {
    isVisible: bool,
    dispatch: func.isRequired,
};

Options.defaultProps = (state) => ({
    isVisible: false,
});
export default Options;
